import request from '@/shared/api/request';

export const getStackletBandwidthData = (
  id: number,
): Promise<{
  statistics: { data: number; name: string; unit: string };
}> =>
  request({
    url: `/stacklets/${id}/statistics/bandwidth/`,
  });
